import API from '@/api'

export default {
  namespaced: true,
  state: {
    open: false,
    isNew: false,
    state: null,
    disableSave: false,
    errors: {
      incorrectElementsSum : false,
    },
    general: {
      name: '',
      stateId: '',
      isSystem: true,
      manufacturer: '',
      price: 0,
      co3: '',
      isCompo: false,
      isBaseDressing: false,
      isSoilGrown: false,
      isHydroponic: false,
      isCompound: false,
      isManureFertilizer: false,
      maximumAvailability: 0,
      data: {
        'Name': '',
        'State': '',
        'Status': '',
        'SpecificWeight': 0, //density
        'PH': 0,
        'NumberOfH': 0,
        'FertSeriesId': 0,
        'MinimumTemp': 0,
        'Manufacturer': '',
        'MolecularWeight': 0,
        'IsCompo': false,
        'IsManureFertilizer': false,
        'IsBaseDressing': false,
        'IsSoilGrown': false,
        'IsHydroponic': false,
        'IsCompound': false,
        'IsSystem': false,
        'FertilizerId': 0,
        'MicroElementsChelated': 0, // or 1
        ElementsConcentration: {
          'N_Val': 0,
          'NO3_Val': 0,
          'NH2_Val': 0,
          'NH4_Val': 0,
          'P_Val': 0,
          'K_Val': 0,
          'Ca_Val': 0,
          'Mg_Val': 0,
          'S_Val': 0,
          'B_Val': 0,
          'Fe_Val': 0,
          'Mn_Val': 0,
          'Zn_Val': 0,
          'Cu_Val': 0,
          'Mo_Val': 0,
          'Na_Val': 0,
          'HCO3_Val': 0,
          'CO3_Val': 0,
          'Cl_Val': 0,
          'F_Val': 0,
        },
        Solubility: {
          'Sol_0C': 0,
          'Sol_5C': 0,
          'Sol_10C': 0,
          'Sol_15C': 0,
          'Sol_20C': 0,
          'Sol_25C': 0,
          'Sol_30C': 0,
        },
      },
    },
    typeAlias: {
      '1': 'SOLID',
      '2': 'SOLID',
      '5': 'SOLID',
      '3': 'Acid',
      '4': 'Liquid',
      '6': 'Liquid',
    },
    states: [
      {
        id: 1,
        name: 'Solid'
      },
      {
        id: 2,
        name: 'SolidChelate'
      },
      {
        id: 3,
        name: 'LiquidAcid'
      },
      {
        id: 4,
        name: 'Liquid'
      },
      {
        id: 5,
        name: 'SolidManure'
      },
      {
        id: 6,
        name: 'LiquidManure'
      },
    ]
  },
  mutations: {
    setOpen (state, flag) {
      state.open = flag;
    },
    setData (state, data) {
      delete data.created_at;
      delete data.updated_at;
      delete data.deleted_at;
      if (data.data.Fertilizer) {
        data.data = data.data.Fertilizer;
      }

      state.general = data;
    },
    setN (state) {
      state.general.data.ElementsConcentration['N_Val'] =
        state.general.data.ElementsConcentration['NO3_Val']
        + state.general.data.ElementsConcentration['NH2_Val']
        + state.general.data.ElementsConcentration['NH4_Val'];
    },
    setState(state, id) {
      if(id == 2) { state.general.data.MicroElementsChelated = 1 }
      else { state.general.data.MicroElementsChelated = 0 }

      if(id == 5 || id == 6) { state.general.isManureFertilizer = 1 }
      else { state.general.isManureFertilizer = 0 }

      if(id == 1 || id == 2 || id == 5) {
        return state.state = 'solid';
      } else if (id == 3) {
        return state.state = 'acid';
      } else if (id == 4 || id == 6)
        return state.state = 'liquid';
      else {
        return state.state = null;
      }
    },
    setDisabledSave(state, bool) {
      state.disableSave = bool;
      state.errors.incorrectElementsSum = bool;
    }

  },
  actions: {
    reset ({state}) {
      state.general = {
        name: '',
        stateId: '',
        isSystem: true,
        manufacturer: '',
        price: 0,
        co3: '',
        isCompo: false,
        isBaseDressing: true,
        isSoilGrown: true,
        isHydroponic: true,
        isCompound: false,
        isManureFertilizer: false,
        maximumAvailability: 0,
        data: {
          'Name': '',
          'State': '',
          'Status': '',
          'SpecificWeight': 0, //density
          'PH': 0,
          'NumberOfH': 0,
          'FertSeriesId': 0,
          'MinimumTemp': 0,
          'Manufacturer': '',
          'MolecularWeight': 0,
          'IsCompo': false,
          'IsManureFertilizer': false,
          'IsBaseDressing': true,
          'IsSoilGrown': true,
          'IsHydroponic': true,
          'IsCompound': false,
          'IsSystem': false,
          'FertilizerId': 0,
          'MicroElementsChelated': 0, // or 1
          ElementsConcentration: {
            'N_Val': 0,
            'NO3_Val': 0,
            'NH2_Val': 0,
            'NH4_Val': 0,
            'P_Val': 0,
            'K_Val': 0,
            'Ca_Val': 0,
            'Mg_Val': 0,
            'S_Val': 0,
            'B_Val': 0,
            'Fe_Val': 0,
            'Mn_Val': 0,
            'Zn_Val': 0,
            'Cu_Val': 0,
            'Mo_Val': 0,
            'Na_Val': 0,
            'HCO3_Val': 0,
            'CO3_Val': 0,
            'Cl_Val': 0,
            'F_Val': 0,
          },
          Solubility: {
            'Sol_0C': 0,
            'Sol_5C': 0,
            'Sol_10C': 0,
            'Sol_15C': 0,
            'Sol_20C': 0,
            'Sol_25C': 0,
            'Sol_30C': 0,
          },
        }
      };
    },
    open ({commit, state, rootGetters, dispatch}, {open, isNew = null}) {
      commit('setOpen', open);

      if (isNew != null) {
        state.isNew = isNew;
        if (!isNew) {
          commit('setData', rootGetters['fertilizers/original']);
          commit('setState', rootGetters['fertilizers/original'].stateId);
        } else {
          dispatch('reset');
        }
      }
    },
    save ({commit, state, rootGetters, dispatch}) {

      state.general.co3 = state.general.data.ElementsConcentration['CO3_Val'];
      state.general.data['Name'] = state.general.name;
      state.general.data['State'] = state.general.stateId;
      state.general.data['Manufacturer'] = state.general.manufacturer;
      state.general.isCompo = state.general.isCompound;
      state.general.data['IsCompo'] = state.general.isCompo;
      state.general.data['IsCompound'] = state.general.isCompound;
      state.general.data['IsBaseDressing'] = state.general.isBaseDressing;
      state.general.data['IsSoilGrown'] = state.general.isSoilGrown;
      state.general.data['IsSystem'] = state.general.isSystem;
      state.general.data['IsHydroponic'] = state.general.isHydroponic;
      state.general.data['IsManureFertilizer'] = state.general.isManureFertilizer;

      if (state.isNew) {
        // state.general.data['SpecificWeight'] = state.general.data['SpecificWeight'] * 1000;
        state.general.data.maximumAvailability = state.general.maximumAvailability

        return API.fertilizers.createFertilizer(state.general).then(res => {
          // state.general.data['SpecificWeight'] = state.general.data['SpecificWeight'] / 1000;
          console.log(res)
          return res;
        });
      } else {
        state.general.maximumAvailability = state.general.data.maximumAvailability

        return API.fertilizers.editFertilizer(state.general);
      }
    },
    validFertilizer({state, commit, rootGetters}) {

      let data = state.general;
      let concentrations = data.data.ElementsConcentration;
      delete concentrations.N_Val;

      commit('setDisabledSave', true);

      if(sum(concentrations) > 100 || sum(concentrations) <= 0) {
        commit('setDisabledSave', true);
         // = true;
      } else {
        commit('setDisabledSave', false);
        // state.errors.incorrectElementsSum = false;
      }

      if(data.stateId == 5 || data.stateId == 6) {
        if(!data.maximumAvailability && rootGetters['fertilizers/popup/isNew']) {
          commit('setDisabledSave', true);
        }
        if(!data.data.maximumAvailability && !rootGetters['fertilizers/popup/isNew']) {
          commit('setDisabledSave', true);
        }
        if(!data.data['ElementsConcentration']['NH2_Val']) {
          commit('setDisabledSave', true);
        }
      }

      if(state.state == 'liquid' && data.stateId != 5 && data.stateId != 6) {

        if(!data.data.SpecificWeight) {
          commit('setDisabledSave', true);
        }
      }

      if(state.state == 'acid') {
        commit('setDisabledSave', false);
        if(!data.data.MolecularWeight || !data.data.NumberOfH || !data.data.SpecificWeight) {
          commit('setDisabledSave', true);
        }
      }

      function sum(obj) { return Object.keys(obj).reduce((sum,key)=>sum+parseFloat(obj[key]||0),0); }
    }
  },
  getters: {
    open (state) {
      return state.open;
    },
    errors(state) {
      return state.errors;
    },
    general (state) {
      return state.general;
    },
    states (state) {
      return state.states;
    },
    state (state) {
      return state.state;
    },
    isNew (state) {
      return state.isNew;
    },
    disableSave(state) {
      return state.disableSave;
    },
    flagPerc (state) {
      var res = 0;

      for (var key in state.general.data.ElementsConcentration) {
        if (key != 'N_Val') {
          res += state.general.data.ElementsConcentration[key];
        }
      }

      if (res > 100) {
        return false;
      }
      return true;
    }
  }
}
